var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 74,
    viewBox: "0 0 64 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2289 30.5059L38.2379 33.396L32 29.7869V24.0137L43.2289 30.5059Z",
    fill: "#007DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0019 24.0137V29.7869L25.7605 33.396L20.7695 30.5059L32.0019 24.0137Z",
    fill: "#007DF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2289 30.5059L38.2379 33.396L32 29.7869V24.0137L43.2289 30.5059Z",
    fill: "url(#paint0_linear_1062_6574)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0019 24.0137V29.7869L25.7605 33.396L20.7695 30.5059L32.0019 24.0137Z",
    fill: "url(#paint1_linear_1062_6574)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2289 30.5059L38.2379 33.396L32 29.7869V24.0137L43.2289 30.5059Z",
    fill: "url(#paint2_linear_1062_6574)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0019 49.9882V44.215L25.7605 40.6094L20.7695 43.496L32.0019 49.9882Z",
    fill: "#007DF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49.9882L43.2289 43.496L38.2379 40.6094L32 44.215V49.9882Z",
    fill: "#007DF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49.9882L43.2289 43.496L38.2379 40.6094L32 44.215V49.9882Z",
    fill: "url(#paint3_linear_1062_6574)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0019 49.9882V44.215L25.7605 40.6094L20.7695 43.496L32.0019 49.9882Z",
    fill: "url(#paint4_linear_1062_6574)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7695 43.4777L26.3279 40.2649L20.7695 39.7773V43.4777Z",
    fill: "#007DF2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7695 30.8398V36.8761L25.8516 33.7966L20.7695 30.8398Z",
    fill: "#007DF2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2383 37.2324V43.2687L38.1562 40.1857L43.2383 37.2324Z",
    fill: "#007DF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7695 36.8725L38.1488 40.1835L43.2308 37.2302L25.8516 33.793L20.7695 36.8725Z",
    fill: "#007DF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0023 18.498L37.3906 33.6606H64.0023V18.498Z",
    fill: "#007DF2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0V16.4463L49.775 26.7231L63.9985 18.4981L32 0Z",
    fill: "#007DF2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.002 0L0 18.4981L14.227 26.7231L32.002 16.4463V0Z",
    fill: "#007DF2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.498V55.5049L14.227 47.28V26.723L0 18.498Z",
    fill: "#007DF2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.227 47.2733L32.002 57.5501V73.9999L0 55.4982L14.227 47.2733Z",
    fill: "#007DF2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.775 47.2733L63.9985 55.4982L32 73.9999V57.5501L49.775 47.2733Z",
    fill: "#007DF2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0V16.4463L49.775 26.7231L63.9985 18.4981L32 0Z",
    fill: "url(#paint5_linear_1062_6574)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.227 47.2733L0 55.4982L32.002 73.9999V57.5501L14.227 47.2733Z",
    fill: "url(#paint6_linear_1062_6574)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_6574",
    x1: 34.7249,
    y1: 25.9568,
    x2: 41.1221,
    y2: 35.2009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_6574",
    x1: 27.6309,
    y1: 29.4116,
    x2: 17.8453,
    y2: 34.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_6574",
    x1: 33.7092,
    y1: 27.251,
    x2: 52.063,
    y2: 40.8175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1062_6574",
    x1: 32,
    y1: 45.2988,
    x2: 43.2289,
    y2: 45.2988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1062_6574",
    x1: 29.277,
    y1: 48.0416,
    x2: 22.8798,
    y2: 38.7975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1062_6574",
    x1: 39.7615,
    y1: 5.53822,
    x2: 57.9951,
    y2: 31.8759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1062_6574",
    x1: 0,
    y1: 60.6366,
    x2: 32.002,
    y2: 60.6366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7dafaa47dcfe002f0f281e081491a367.svg";
export { ForwardRef as ReactComponent };